var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42171 11.0001L18 11.0001L18 9.0001L6.41397 9.00009L10.7071 4.70722L9.29291 3.29297L3.29294 9.2926L2.58368 10.0018L3.29504 10.7089L4 9.99976L3.29508 10.709L3.2952 10.7091L3.29569 10.7096L3.29768 10.7116L3.30559 10.7194L3.33674 10.7504L3.45719 10.8702L3.90485 11.3157C4.28539 11.6945 4.81701 12.2241 5.42128 12.827C6.63021 14.0333 8.12848 15.5317 9.28953 16.7038L10.7105 15.2964C9.54507 14.1198 8.04336 12.618 6.83392 11.4113C6.69218 11.2698 6.55445 11.1325 6.42171 11.0001Z",
    fill: "#2E3438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.e9df6da3d1dafe85ecdaf9cc4c9fca99.svg";
export { ForwardRef as ReactComponent };